module.exports = __webpack_public_path__ + "media/images/products/IMG_20210704_164213_HDR-removebg-preview-15cc301248a581da33cc1d7bcf66fbbf.png";